import React from 'react';
import { Spinner, Row, Col } from 'seduo-ui';
export default class Example extends React.Component {
    render() {
        return (<Row>
                <Col md={2}>
                    <Row>
                        <Spinner />
                    </Row>
                </Col>
                <Col md={2}>
                    <Row>
                        <Spinner color="dark"/>
                    </Row>
                </Col>
                <Col md={2}>
                    <Row className="bg-brand-light">
                        <Spinner color="light"/>
                    </Row>
                </Col>
                <Col md={2} className="m-5">
                    <Row>
                        <Spinner size="middle"/>
                        <Spinner size="small"/>
                    </Row>
                </Col>
            </Row>);
    }
}
